import React from 'react';

import {CurrentOddsModuleController} from "../current-odds-module.controller";
import {CurrentOddsModuleProps} from "../models/current-odds-module.props";
import {Compose, ComposeSettings} from "../../../../../core/components/composers/compose";
import {CurrentOddsModuleRow} from "./current-odds-module.row";
import {GAME_STATUSES} from "../../../../../core/app/consts";
import {WidgetWrapper} from "../../../../../core/components/misc/widget-wrapper/widget-wrapper";
import {PreMatchOddsModuleComponent} from "./pre-match-odds-module";
import classNames from "classnames";
import styles from "../styles/current-odds.module.scss"

export class CurrentOddsModuleComponentProps extends CurrentOddsModuleProps {}

export const CurrentOddsModuleComponent = ({controller}: CurrentOddsModuleComponentProps) => {
  const {state, terms} = controller;
  const {bookmaker, currentRates, sportTypeId, hasValidCurrentRates, hasValidPreMatchRates, statusGroup} = state;
  const {ODDS_COMPARISON_LIVE, MATCH_RESULT_ODDS} = terms;

  const betsImpressionParams = {
    bookieId: bookmaker.id,
    bookieName: bookmaker.name,
    sportTypeId: sportTypeId,
  };

  const currentRowProps = {
    controller,
    betsImpressionParams,
    rates: currentRates,
    title: hasValidCurrentRates && ODDS_COMPARISON_LIVE,
    showOriginalOdds: statusGroup !== GAME_STATUSES.ended,
    isLiveMatch: true
  };

  if (!hasValidCurrentRates && !hasValidPreMatchRates) {
    return null;
  }

  const cardWrapperProps = {
    controller,
    title: MATCH_RESULT_ODDS,
  }

  const preMatchProps = {
    controller,
    betsImpressionParams,
    showOriginalOdds: statusGroup !== GAME_STATUSES.ended
  }

  return (
    <WidgetWrapper {...cardWrapperProps}>
      <div className={classNames(styles.current_odds_module_container)}>
        {
          hasValidCurrentRates ? <CurrentOddsModuleRow {...currentRowProps}/> : null
        }
        <PreMatchOddsModuleComponent {...preMatchProps}/>
      </div>
    </WidgetWrapper>
  )
};

const settings: ComposeSettings = {
  component: CurrentOddsModuleComponent,
  propsType: CurrentOddsModuleComponentProps,
  controllerType: CurrentOddsModuleController,
  shouldTriggerOnRenderComplete: true,

  createModule: true,
  observe: true
};

export const CurrentOddsModule = Compose(settings);
